import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import APIS from "../../constant/EndPoint";
import TableActionButton from "../Reusable/TableActionButton";
import useGetHook from "../../customHooks/useGetHook";
import SwitchButton from "../Reusable/SwitchButton";

const BranchList = (props:any) => {
  const {handleIsActive} = props
  const defaultColumns: any = [
    {
      header: "S.N",
      accessorKey: ".",
      cell: ({ row }: any) => <>{row?.index + 1}</>,
    },
    {
      header: "Name",
      accessorKey: "name",
      cell: NACell,
    },
    {
      header: "VAT/PAN",
      accessorKey: "vat_pan",
      cell: NACell,
    },
    {
      header: "Contact",
      accessorKey: "primary_contact",
      cell: NACell,
    },
    {
      header: "Email",
      accessorKey: "primary_email",
      cell: NACell,
    },
    {
      header: "Warehouse",
      accessorKey: "warehouse.name",
      cell: NACell,
    },
    {
      header: "Branch Manager",
      accessorKey: "branch_manager.name",
      cell: NACell,
    },
    {
      header: "Active",
      accessorKey: "is_active",
      cell: ({ row, getValue }) => (
        <SwitchButton
          id={row?.original?.id}
          value={getValue()}
          disabled={false}
          onChange={handleIsActive}
        />
      )
    },
  ];
  const { data: userProfileType } = useGetHook({
    queryKey: [`user-profile`],
    url: `${APIS.USER_PROFILE}`,
    params: {},
  });

  if (userProfileType?.is_staff) {
    defaultColumns.push({
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => (
        <>
          <TableActionButton editPath={`edit/${getValue()}`} />
        </>
      ),
    },)
  }
  return (
    <DataTable
      url={APIS.BRANCH}
      queryKey={"branch"}
      columns={defaultColumns}
      addNewPagePath={userProfileType?.is_staff ? "/create-branch":""}
      tableName={"Branch"}
      isUpload={!!userProfileType?.is_staff}
    />
  );
};

export default BranchList;
